export default __webpack_public_path__ + "static/media/icon_billing_pressed.98b1c45a.svg";